module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-7-74fe6007c5e28cf377e206ce4fa4f0d0.jpg";